<template>
  <div class="section">
    <div class="section-header">
      <h3>약정할인 프로그램(LTE플러스)위약금제도 안내</h3>
    </div>
    <div class="section-body">
      <dl class="field-group">
        <dt class="field-label">
          위약금제도 안내 및 동의
        </dt>
        <dd class="field-control">
          <div>
            <ul class="notice-text-list">
              <li class="notice-text">
                ’14년 12월 1일 이후 가입자는 단말지원금 및 선택약정과 중복되는
                기간 동안 할인 반환금이 부과되지 않음. 단, 이전 가입자는 할인
                반환금 산정 기준에 따라 반환금이 발생함
              </li>
              <li class="notice-text">
                약정기간 중 위약 발생시 [약정할인 비대상 요금제로의 변경,
                계약해지(요금미납, 단말기 분실/파손 등 사유 포함), 명의변경
                (양수인이 약정 미승계의 경우, 약청 철회] 해당월의 요금할인은
                제공되지 않으며, 할인 반환금이 부과됨
              </li>
            </ul>
            <div class="form-control-sub">
              <table
                class="section-grid"
                cellspacing="0"
                cellpadding="0"
                border="0"
                summary="위약금 계산을 안내하는 표"
              >
                <caption>
                  약정기간내 해지시 위약금 안내
                </caption>
                <colgroup>
                  <col width="30%" />
                  <col width="70%" />
                </colgroup>
                <thead>
                  <tr>
                    <th scope="col" class="first">대상구간</th>
                    <th scope="col">위약금 계산공식 (단계별 합산)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1~6개월차</td>
                    <td class="last">해당기간 약정할인 금액 x 100%</td>
                  </tr>
                  <tr>
                    <td>7~12개월차</td>

                    <td class="last">해당기간 약정할인 금액 x 50%</td>
                  </tr>
                  <tr>
                    <td>13~16개월차</td>

                    <td class="last">해당기간 약정할인 금액 x 30%</td>
                  </tr>
                  <tr>
                    <td>17~20개월차</td>

                    <td class="last">해당기간 약정할인 금액 x -20%</td>
                  </tr>
                  <tr>
                    <td>21~25개월차</td>

                    <td class="last">해당기간 약정할인 금액 x -40%</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="form-control-sub">
              <div
                id="checkbox-container-penalty-agreement"
                class="input-container"
              >
                <input
                  id="penalty-agreement-check"
                  ref="ref_agreePenaltyChk"
                  v-model="agreePenaltyChk"
                  type="checkbox"
                  name="penalty-agreement"
                  class="input-checkbox input-text"
                />
                <label for="penalty-agreement-check" class="input-label"
                  ><em class="primary-text">(필수)</em> 상기내용을 이해하였으며
                  내용을 동의합니다.</label
                >
              </div>
            </div>
          </div>
        </dd>
      </dl>
    </div>
    <v-dialog />
  </div>
</template>

<script>
export default {
  name: 'PenaltySectionView',

  components: {},

  data() {
    return {
      agreePenaltyChk: false
    }
  },

  methods: {
    /** 
     * Function    : validCondition
     * Description : 위약금제도 필수값 validation
     **/
    validCondition() {
      let regExp
      let title = '온라인 가입신청 안내'
      if (!this.agreePenaltyChk) {
        this.openAlert(
          title,
          '위약금제도 안내 및 동의여부를 확인하세요.',
          this.$refs.ref_agreePenaltyChk
        )
        return false
      }
      return true
    },
    
    /** 
     * Function    : openAlert
     * Description : 기본 alert 호출 함수
     **/
    openAlert(title, message, ref) {
      this.$modal.show('dialog', {
        title: title,
        text: message,
        buttons: [
          {
            title: '확인',
            class: 'primary-button',
            handler: () => {
              this.$modal.hide('dialog')
              if (ref) {
                ref.focus()
              }
            }
          }
        ]
      })
    }
  }
}
</script>

<style scoped></style>
